__turbopack_context__.v({
  "active": "InfoSlider-module__9MRQ1a__active",
  "navBtn": "InfoSlider-module__9MRQ1a__navBtn",
  "navButtons": "InfoSlider-module__9MRQ1a__navButtons",
  "primary": "InfoSlider-module__9MRQ1a__primary",
  "secondary": "InfoSlider-module__9MRQ1a__secondary",
  "slide": "InfoSlider-module__9MRQ1a__slide",
  "slideContent": "InfoSlider-module__9MRQ1a__slideContent",
  "slideImage": "InfoSlider-module__9MRQ1a__slideImage",
  "sliderBox": "InfoSlider-module__9MRQ1a__sliderBox",
  "sliderContainer": "InfoSlider-module__9MRQ1a__sliderContainer",
  "sliderWrapper": "InfoSlider-module__9MRQ1a__sliderWrapper",
  "slides": "InfoSlider-module__9MRQ1a__slides",
  "success": "InfoSlider-module__9MRQ1a__success",
});
